import { fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';
import { entities, brands, publishers, keywords } from 'api';

/*  ACTION TYPES  */
export const FETCH_FOLLOWED_ENTITIES = 'FETCH_FOLLOWED_ENTITIES';
export const FETCHED_FOLLOWED_ENTITIES = 'FETCHED_FOLLOWED_ENTITIES';
export const SET_FOLLOWED_ENTITIES_FILTER = 'SET_FOLLOWED_ENTITIES_FILTER';

export const FETCH_TRENDING_BRANDS = 'FETCH_TRENDING_BRANDS';
export const FETCHED_TRENDING_BRANDS = 'FETCHED_TRENDING_BRANDS';

export const FETCH_TRENDING_PUBLISHERS = 'FETCH_TRENDING_PUBLISHERS';
export const FETCHED_TRENDING_PUBLISHERS = 'FETCHED_TRENDING_PUBLISHERS';

export const FETCH_TRENDING_KEYWORDS = 'FETCH_TRENDING_KEYWORDS';
export const FETCHED_TRENDING_KEYWORDS = 'FETCHED_TRENDING_KEYWORDS';

export const TOGGLE_COMING_SOON_MODAL = 'TOGGLE_COMING_SOON_MODAL';

/* THUNKS */
export const fetchFollowedEntities = clear => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().Home.followedEntitiesList,
    fetchingActionType: FETCH_FOLLOWED_ENTITIES,
    fetchedActionType: FETCHED_FOLLOWED_ENTITIES,
    apiCall: (filters) => entities.getRecentEntities(filters),
  });


export const fetchTrendingBrands = clear => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().Home.trendingBrandsList,
    fetchingActionType: FETCH_TRENDING_BRANDS,
    fetchedActionType: FETCHED_TRENDING_BRANDS,
    apiCall: (filters) => brands.getTrendingBrands(filters),
  });

export const fetchTrendingPublishers = clear => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().Home.trendingPublishersList,
    fetchingActionType: FETCH_TRENDING_PUBLISHERS,
    fetchedActionType: FETCHED_TRENDING_PUBLISHERS,
    apiCall: (filters) => publishers.getTrendingPublishers(filters),
  });

export const fetchTrendingKeywords = clear => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().Home.trendingKeywordsList,
    fetchingActionType: FETCH_TRENDING_KEYWORDS,
    fetchedActionType: FETCHED_TRENDING_KEYWORDS,
    apiCall: (filters) => keywords.getTrendingKeywords(filters),
  });
